import { ExIcon, IconSize } from '@boomi/exosphere';
import { type FormEvent, useEffect, useState } from 'react';
import type { TriggerFieldInputProps } from '../../types/types';

const SelectButtonsField = ({ option, id, value, onChange }: TriggerFieldInputProps) => {
    const [selectOptions, setSelectOptions] = useState<Record<string, string> | null>(
        option.options || null,
    );

    const radioGroupName = id;

    const onRadioChange = (e: FormEvent<HTMLInputElement>) => {
        onChange(option.id, e.currentTarget.value);
    };

    const onRadioClear = (e: FormEvent<HTMLInputElement>) => {
        if (value === e.currentTarget.value) {
            onChange(option.id, null);
        }
    };

    const onMultiCheckboxChange = (e: FormEvent<HTMLInputElement>) => {
        if (((value as string[]) || []).includes(e.currentTarget.value)) {
            onChange(
                option.id,
                (value as string[]).filter((i) => i !== e.currentTarget.value),
            );
        } else {
            onChange(option.id, [...((value as string[]) || []), e.currentTarget.value]);
        }
    };

    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    useEffect(() => {
        if (option.optionsRemote) {
            setSelectOptions({});
        }
    }, []);

    const isMultiSelect = option.type === 'MultiSelectButtons';

    return Object.keys(selectOptions || {}).length > 0 ? (
        <section className="select-chips">
            {Object.entries(selectOptions || {}).map(([key, label]) => (
                <label key={id + key} htmlFor={id + key} className="text sm">
                    {isMultiSelect && (
                        <ExIcon
                            className={
                                ((value as string[]) || []).includes(key)
                                    ? 'icon-selected'
                                    : 'icon-not-selected'
                            }
                            icon={((value as string[]) || []).includes(key) ? 'Check' : 'Close'}
                            size={IconSize.S}
                            hide-browser-tooltip
                        />
                    )}
                    {label}
                    <input
                        type={isMultiSelect ? 'checkbox' : 'radio'}
                        id={id + key}
                        name={id + radioGroupName}
                        value={key}
                        onChange={isMultiSelect ? onMultiCheckboxChange : onRadioChange}
                        checked={
                            isMultiSelect
                                ? ((value as string[]) || []).includes(key)
                                : key === value
                        }
                        onClick={isMultiSelect ? undefined : onRadioClear} // reset a radio selection
                    />
                </label>
            ))}
        </section>
    ) : null;
};

export default SelectButtonsField;
